import { waitForAll } from '@mimir/common/async/async';
import { makePriority, PrioritySemaphore } from '@mimir/common/async/prioritySemaphore';
import type { ItemMediaUsagesRequestDto } from '@mimir/common/dto/itemMediaUsageDto';
import { updateItemMediaUsage } from '@mimir/web/util/api';
import { logErrorAndShowToast } from './uiError';

export const updateItemsMediaUsage = async (itemIds: string[], mediaUsageDto: ItemMediaUsagesRequestDto) => {
  const semaphore = new PrioritySemaphore(10);
  const postPromises: Promise<void>[] = [];

  for (const itemId of itemIds) {
    postPromises.push(
      semaphore.limit(async () => await updateItemMediaUsage(itemId, mediaUsageDto), makePriority(), null)
    );
  }

  try {
    await waitForAll(postPromises);
  } catch (error) {
    logErrorAndShowToast('Failed to update item media usage', error);
  }
};
